
  import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
  import debounce from 'lodash/debounce';
  import { JobDocumentCreatedMessage } from '@/services/eventbus.models';
  import { EventBus } from '@/event-bus';
  import { Client, DocumentModel, IDocumentModel, DocumentType as DocumentModelDocumentType } from '@/services/api.service';
  import { EnumModel, DocumentType, DocumentTypeEnums } from '@/common/enumerations';
  import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';

  const NoFolder: string = '(No Folder)';

  @Component({
    props: {
      jobGid: String,
      isInDialogMode: Boolean,
      folders: Array as () => string[]
    }
  })
  export default class UploadDocument extends Vue {
    private availableDocumentTypes: EnumModel[] = [];
    private documentType: EnumModel | null = null;
    private name: string = '';
    private folderName: string = '';
    private selectedFolderName: string | null = null;
    private newFolderName: string = '';
    private files: File[] = [];
    private isUploading: boolean = false;
    private currentMessage: string = '';
    private dropZoneEnabled: boolean = true;
    private highlight: boolean = true;

    private enableFolderNameEntry: boolean = true;

    private hasSelectedFile: boolean = false;
    private selectedFileName: string = '';

    protected mounted() {
      this.availableDocumentTypes.push(...DocumentTypeEnums);
      this.documentType = this.availableDocumentTypes[0];
      console.log('Mounted: DocType:', this.documentType);
    }

    private openFileSelection(): void {
      if (!this.dropZoneEnabled) {
        return;
      }
      (this.$refs.fileselector as HTMLElement).click();
    }

    private onDragOver(event: any): void {
      console.log('Drag over...');
      if (!this.dropZoneEnabled) {
        return;
      }
      event.preventDefault();
      this.highlight = true;
    }

    private onDragLeave(event: DragEvent): void {
      console.log('Drag leave...');
      this.highlight = false;
    }

    @Watch('documentType', { immediate: true })
    private onPropertyChanged(value: any, oldValue: any) {
      // Do stuff with the watcher here.
      console.log('DocumentType changed', value);
    }

    @Watch('selectedFolderName')
    private onSelectedFolderNameChanged(value: string | null, oldValue: string | null) {
      this.enableFolderNameEntry = value === null;
      if (value === null || value === NoFolder) {
        this.folderName = '';
      } else {
        this.folderName = value;
      }
    }
    private onDrop(event: DragEvent): void {
      console.log('Drop...');
      if (!this.dropZoneEnabled) {
        return;
      }

      event.preventDefault();
      if (event.dataTransfer) {
        // const files = event.dataTransfer.files;
        // let result: File[] = [];
        // for (var i = 0; i < files.length; i++) {
        //   result.push(<File>files.item(i));
        // }
        // this.$emit('filesAdded', result);
        const localFiles: FileList = event.dataTransfer.files;
        for (let i = 0; i < localFiles.length; i++) {
          this.files.push(localFiles.item(i) as File);
        }
        this.highlight = false;
        this.updateName();
      }
    }

    private handleFileSelected(event: any) {
      console.log('Handle file selected');
      const localFiles: FileList = event.target.files;
      for (let i = 0; i < localFiles.length; i++) {
        this.files.push(localFiles.item(i) as File);
      }
      this.updateName();
    }

    private updateName() {
      // get the first file and update the Name propery
      const f = this.files[0];
      if (this.name === '') {
        this.name = f.name;
      }
      this.selectedFileName = f.name;
      this.hasSelectedFile = true;
    }

    private uploadDocument() {
      // @ts-ignore
      this.$Progress.start();
      this.isUploading = true;
      this.currentMessage = 'Uploading file...';
      const baseUrl = process.env.VUE_APP_API_URL;
      const url = baseUrl + '/api/v1/file/documents/upload';

      let theFolderName: string = this.folderName;
      if (this.enableFolderNameEntry) {
        theFolderName = this.newFolderName;
      }
      const formData = new FormData();
      formData.append('file', this.files[0]);
      formData.append('name', this.name);
      formData.append('folderName', theFolderName);
      formData.append('jobGid', this.$props.jobGid);
      if (this.documentType) {
        formData.append('type', this.documentType.value.toString());
      }
      axios
        .post(url, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then(response => {
          console.log('SUCCESS!!');
          console.log(response);
          this.isUploading = false;
          this.onDocumentUploaded(response.data as DocumentModel);
        })
        .catch(error => {
          // @ts-ignore
          this.$Progress.fail();
          // @ts-ignore
          this.$awn.alert('Failed to create the job item.\r\n' + error);
        });
    }

    private onDocumentUploaded(document: IDocumentModel) {
      // @ts-ignore
      this.$Progress.finish();
      // @ts-ignore
      this.$awn.success('Document uploaded created successfully');
      // Raise the created events, and publish the event on the bus
      this.$emit('job-document-uploaded', document);
      EventBus.$emit('job-document-uploaded', new JobDocumentCreatedMessage(this.$props.jobGid, document));
      this.closeModal();
    }

    private cancelUpload() {
      console.log('Cancelling upload...');
      // this.$emit('close');
      this.closeModal();
    }

    private closeModal() {
      if (this.$props.isInDialogMode) {
        this.$modal.hide('modal-jobdocument-upload');
      }
    }
  }
